import { FC } from 'react';

import { useTheme } from '@mui/material';
import round from 'lodash/round';

import { Icons, Typography, Box } from '@cast/design-system';

const IndicatorIcon: FC<{ value: number }> = ({ value }) => {
  const { palette } = useTheme();

  if (value === 0) {
    return null;
  } else if (value > 0) {
    return (
      <Icons.CaretUp
        data-testid="indicator-caret-up"
        weight="fill"
        color={palette.red[400]}
      />
    );
  } else {
    return (
      <Icons.CaretDown
        data-testid="indicator-caret-down"
        weight="fill"
        color={palette.green[500]}
      />
    );
  }
};

export const CostChangePercentageCell: FC<{ value?: string }> = ({ value }) => {
  const emptyJsx = (
    <Typography variant="inherit" fontWeight="regular" noWrap>
      -
    </Typography>
  );

  if (!value) {
    return emptyJsx;
  }

  const valueRounded = round(Number(value), 2);
  const valueWithMinusRemoved = Math.abs(valueRounded);

  if (valueRounded === 0) {
    return emptyJsx;
  }

  return (
    <Box display="flex" alignItems="center" gap={8}>
      <IndicatorIcon value={valueRounded} />
      <Typography variant="inherit" fontWeight="regular" noWrap>
        {`${valueWithMinusRemoved}%`}
      </Typography>
    </Box>
  );
};
